import React, {createContext, useContext, useReducer} from 'react'
import {LEDControllerOverviewReducer} from "../reducer/LEDControllerOverviewReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const LEDControllerOverviewContext = createContext();

const LEDControllerOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        ledControllerDeviceInformation: {},
        aisleTypes: new Set(),
        ledControllerTypes: [],
        selectedDefaultValues: {},
        loadingOverview: true,
        monitoringStatusLoadingDevices: {}
    }
    const [viewModel, dispatch] = useReducer(LEDControllerOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }

    return (
        <LEDControllerOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </LEDControllerOverviewContext.Provider>
    )
}

export default LEDControllerOverviewContextProvider


// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/context/LEDControllerOverviewContext.js